import { Params, Result } from 'types';
import fetch from 'utils/fetch';

import { GeneralSearchItem } from './types';

export async function postGeneralSearch(
  params: Params
): Promise<Result<GeneralSearchItem>> {
  const response = await fetch(`/api/search/v2`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params),
  });
  const result = await response.json();

  return result;
}
